"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSeries = void 0;
function mapSeries(values, fn) {
    return values.reduce((p, v) => p.then(r => fn(v).then(v => (r.push(v), r))), Promise.resolve([]));
}
exports.mapSeries = mapSeries;
//# sourceMappingURL=mapSeries.js.map